import { ORDER_TYPES } from "../constants"
import { IDateRange } from "../../../types/filter"

interface IBuildFetchSponsoredProductParams {
  dateRange: IDateRange
  isOrder: boolean
  filterIds: string[]
}

export function buildFetchSponsoredProductParams({
  dateRange,
  isOrder,
  filterIds,
}: IBuildFetchSponsoredProductParams) {
  return {
    fromDate: dateRange.from,
    toDate: dateRange.to,
    filterType: isOrder ? ORDER_TYPES.ORDERS : ORDER_TYPES.DATE,
    filterIds,
  }
}
